import { createAsyncActionTypes } from "../utils";

export const GET_REQUESTS = createAsyncActionTypes("GET_REQUESTS");
export const CLEAR_ADD_FUEL_REQUEST_RESPONSE =
  "CLEAR_ADD_FUEL_REQUEST_RESPONSE";
export const CANCEL_REQUEST = createAsyncActionTypes("CANCEL_REQUEST");
export const SEND_FEEDBACK = createAsyncActionTypes("SEND_FEEDBACK");